// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"20a3147b","383":"3566e733","492":"c931ab5c","574":"20a3147b","583":"20a3147b","635":"909e6929","641":"899e5264","672":"909e6929","778":"20a3147b"}[chunkId] + ".chunk.css";
};